import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as libraryFteEstimates from '../../library-fte-estimates'

export const RESOURCE = {
  payload: {
    description:
      'The projected full-time equivalent (FTE) effort of personnel working in the library for cost allocation.',
    dimension: libraryFteEstimates.RESOURCE.payload,
    level: 0,
    name: 'Library FTE Estimate',
    partialId: PartialId.Standard.create('estimate'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
